// @flow
import { ConfSurveysActionTypes } from './constants';

const INIT_STATE = {
    confSurvey: {},
    loading: false,
    error: false,
    formSubmited: false,
};

type ConfSurveysAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { confSurvey?: {} | null, listaConfSurveys?: [] | null, loading?: boolean, +value ?: boolean };

const ConfSurvey = (state: State = INIT_STATE, action: ConfSurveysAction): any => {
    // console.log(action);
    switch (action.type) {
        case ConfSurveysActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case ConfSurveysActionTypes.GET_CONF_SURVEY: {
                    return {
                        ...state,
                        confSurvey: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case ConfSurveysActionTypes.UPDATE_CONF_SURVEY: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }


        case ConfSurveysActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case ConfSurveysActionTypes.GET_CONF_SURVEY: {
                    return {
                        ...state,
                        error: action.payload.error,
                        confSurvey: {},
                        loading: false,
                    };
                }
                case ConfSurveysActionTypes.UPDATE_CONF_SURVEY: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case ConfSurveysActionTypes.GET_CONF_SURVEY:
            return { ...state, error: false, loading: true };
        case ConfSurveysActionTypes.UPDATE_CONF_SURVEY:
            return { ...state, error: false, loading: true };
        case ConfSurveysActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                confSurvey: {},
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default ConfSurvey;
